import { render, staticRenderFns } from "./Winners2021PlaceWinnersCardSubtitle.vue?vue&type=template&id=0aa0a749&"
import script from "./Winners2021PlaceWinnersCardSubtitle.vue?vue&type=script&lang=js&"
export * from "./Winners2021PlaceWinnersCardSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./Winners2021PlaceWinnersCardSubtitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports